import { ApiModule, type PaginatedResponseData } from '@common/index';
import type { PostGraduateEducationTemplateItem, PostGraduateEducationTemplate, PostGraduateEducationTemplateMasterData } from '../models';

export class PostGraduateEducationTemplateApi extends ApiModule {
  protected endpoint = '/post-graduate-education-template';

  public async pagePostGraduateEducationTemplates(params: any) {
    return this.api.post<PaginatedResponseData<PostGraduateEducationTemplateItem>, any>(
      `${this.endpoint}/page?page=${params.page}&size=${params.itemsPerPage}&sort=${params.sort ?? ''}&sort=${params.sort ?? ''}`,
      {
        ...params
      }
    );
  }

  public loadPostGraduateEducationTemplateDetails(id: number) {
    return this.api.get<PostGraduateEducationTemplate>(`${this.endpoint}?id=${id}`);
  }

  public loadMasterData(id: number) {
    return this.api.get<PostGraduateEducationTemplateMasterData>(`${this.endpoint}/master-data?id=${id}`);
  }

  public savePostGraduateEducationTemplate(params: any) {
    return this.api.post(`${this.endpoint}`, {
      ...params
    });
  }

  public copyPostGraduateEducationTemplate(params: any) {
    return this.api.post(`${this.endpoint}/copy`, {
      ...params
    });
  }

  public copyLegislation(params: any) {
    return this.api.post(`${this.endpoint}/copy-legislation`, {
      ...params
    });
  }

  public deletePostGraduateEducationTemplate(id: number) {
    return this.api.delete(`${this.endpoint}?id=${id}`);
  }

  public listPostGraduateEducationTemplateBySpeicalityAndLegislation(specialityId: number, legislationId: number) {
    return this.api.get<PostGraduateEducationTemplateItem[]>(
      `${this.endpoint}/search-by-speciality-and-legislation?specialityId=${specialityId}&legislationId=${legislationId}`
    );
  }
}
